export var ContractProductIdentifier;
(function (ContractProductIdentifier) {
    ContractProductIdentifier["EINSPURIGE"] = "Einspurige";
    ContractProductIdentifier["MEHRSPURIGE"] = "Mehrspurige";
    ContractProductIdentifier["LEGALEXPENSES"] = "LegalExpenses";
    ContractProductIdentifier["GIPB"] = "gipb";
})(ContractProductIdentifier || (ContractProductIdentifier = {}));
export var LiabilitySum;
(function (LiabilitySum) {
    LiabilitySum[LiabilitySum["A"] = 8000000] = "A";
    LiabilitySum[LiabilitySum["B"] = 12000000] = "B";
    LiabilitySum[LiabilitySum["C"] = 15000000] = "C";
    LiabilitySum[LiabilitySum["D"] = 20000000] = "D";
    LiabilitySum[LiabilitySum["E"] = 25000000] = "E";
})(LiabilitySum || (LiabilitySum = {}));
export var DeductibleAmount;
(function (DeductibleAmount) {
    DeductibleAmount[DeductibleAmount["A"] = 290] = "A";
    DeductibleAmount[DeductibleAmount["B"] = 390] = "B";
    DeductibleAmount[DeductibleAmount["C"] = 500] = "C";
    DeductibleAmount[DeductibleAmount["D"] = 750] = "D";
    DeductibleAmount[DeductibleAmount["E"] = 1000] = "E";
    DeductibleAmount[DeductibleAmount["F"] = 1500] = "F";
})(DeductibleAmount || (DeductibleAmount = {}));
export var CascoTypeEnum;
(function (CascoTypeEnum) {
    CascoTypeEnum["VOLLKASKO"] = "Vollkasko";
    CascoTypeEnum["TEILKASKOPARKSCHADEN"] = "Teilkasko mit Parkschaden";
    CascoTypeEnum["TEILKASKO"] = "Teilkasko ohne Parkschaden";
})(CascoTypeEnum || (CascoTypeEnum = {}));
// FIXME: why do we have to define this??
export var DriveTypeEnum;
(function (DriveTypeEnum) {
    DriveTypeEnum["BENZIN"] = "Benzin";
    DriveTypeEnum["DIESEL"] = "Diesel";
    DriveTypeEnum["ELEKTRO"] = "Elektromotor";
    DriveTypeEnum["HYBRID_ELEKTRO"] = "Hybrid mit Elektromotor";
    // Andere Antriebsart //nicht auswählbar als Option
    DriveTypeEnum["WASSERSTOFF"] = "Wasserstoff (I)";
    DriveTypeEnum["HYBRID_WASSERSTOFF_ELEKTRO"] = "Hybrid Wasserstoff/Elektro (J)";
    DriveTypeEnum["BRENNSTOFFZELLE_WASSERSTOFF"] = "Brennstoffzelle/Wasserstoff (M)";
    DriveTypeEnum["BRENNSTOFFZELLE_BENZIN"] = "Brennstoffzelle/Benzin (N)";
    DriveTypeEnum["BRENNSTOFFZELLE_ETHANOL"] = "Brennstoffzelle/Ethanol (P)";
    DriveTypeEnum["BRENNSTOFFZELLE_METHANOL"] = "Brennstoffzelle/Methanol (O)";
    DriveTypeEnum["NOT_LISTED"] = "Antriebsart nicht angef\u00FChrt";
})(DriveTypeEnum || (DriveTypeEnum = {}));
// AdditionalEquipments
export const VehicleAdditionalEquipmentsList = [
    'additionalEquipmentLessThanFourThousand',
    'additionalEquipmentMoreThanFourThousand',
];
